import { render, staticRenderFns } from "./UpdateTicketAppDialogMasterSchool.vue?vue&type=template&id=4b7ce6f3&scoped=true"
import script from "./UpdateTicketAppDialogMasterSchool.vue?vue&type=script&lang=js"
export * from "./UpdateTicketAppDialogMasterSchool.vue?vue&type=script&lang=js"
import style0 from "./UpdateTicketAppDialogMasterSchool.vue?vue&type=style&index=0&id=4b7ce6f3&lang=css"
import style1 from "./UpdateTicketAppDialogMasterSchool.vue?vue&type=style&index=1&id=4b7ce6f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ce6f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7ce6f3')) {
      api.createRecord('4b7ce6f3', component.options)
    } else {
      api.reload('4b7ce6f3', component.options)
    }
    module.hot.accept("./UpdateTicketAppDialogMasterSchool.vue?vue&type=template&id=4b7ce6f3&scoped=true", function () {
      api.rerender('4b7ce6f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/dialog/UpdateTicketAppDialogMasterSchool.vue"
export default component.exports